exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._-_-src-modules-Rating-components-Strap-___styles__strap-block___3oj9B{position:relative}._-_-src-modules-Rating-components-Strap-___styles__points-value___1qX-6{color:#f63;font-size:20px;font-weight:700;margin-right:6px;letter-spacing:1.5px}._-_-src-modules-Rating-components-Strap-___styles__rank___1ac0z{color:#1d89e4;font-weight:700;margin-bottom:6px}._-_-src-modules-Rating-components-Strap-___styles__icon-strap___1zbBT{width:35px;height:35px}._-_-src-modules-Rating-components-Strap-___styles__strapTitle___5mU44{display:-ms-flexbox;display:flex}._-_-src-modules-Rating-components-Strap-___styles__strapTitle___5mU44 svg{margin-right:3px}", ""]);

// exports
exports.locals = {
	"strap-block": "_-_-src-modules-Rating-components-Strap-___styles__strap-block___3oj9B",
	"points-value": "_-_-src-modules-Rating-components-Strap-___styles__points-value___1qX-6",
	"rank": "_-_-src-modules-Rating-components-Strap-___styles__rank___1ac0z",
	"icon-strap": "_-_-src-modules-Rating-components-Strap-___styles__icon-strap___1zbBT",
	"strapTitle": "_-_-src-modules-Rating-components-Strap-___styles__strapTitle___5mU44"
};


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!/var/www/build-health-2/~/postcss-loader!/var/www/build-health-2/src/modules/Rating/components/Strap/styles.css
// module id = 1461
// module chunks = 0